import { Contract } from '@ethersproject/contracts';

const getProviderOrSigner = (provider, account) =>
  account ? provider.getSigner(account) : provider;

export const getContract = (address, abi, provider, account) =>
  new Contract(address, abi, getProviderOrSigner(provider, account));
